import { useState, useEffect } from "react";
import {
  saveTeam,
  updateTeam,
  addTeamMembers,
  removeTeamMembers,
  getTeamsByOrg,
  getTeamById,
} from "../Api/TeamMaster";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Card,
  Table,
  Modal,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { getUsersByOrganization } from "../Api/Auth";
const TeamMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showMembersModal, setShowMembersModal] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [mode, setMode] = useState("create"); // "create" or "edit"
  const [organizationUsers, setOrganizationUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userName = userDetails?.username || "admin";
  const orgId = userDetails?.organisationId;

  const [teamData, setTeamData] = useState({
    teamName: "",
    teamMembers: [],
    orgId: String(orgId) || "",
  });

  console.log("Team Data teamMembers:", teamData);

  const [newMember, setNewMember] = useState("");

  // Fetch teams on component mount
  useEffect(() => {
    fetchTeams();
    fetchOrganizationUsers();
  }, []);

  const fetchTeams = async () => {
    try {
      if (orgId) {
        const teamsData = await getTeamsByOrg(orgId);
        console.log("teamsData", teamsData);
        setTeams(teamsData);
      }
    } catch (error) {
      toast.error(`Error fetching teams: ${error.message}`);
    }
  };

  const fetchOrganizationUsers = async () => {
    try {
      if (orgId) {
        setUsersLoading(true);
        const response = await getUsersByOrganization(orgId);
        console.log("Organization users:", response);
        // Access the users array from the response object
        setOrganizationUsers(response.users || []);
      }
    } catch (error) {
      toast.error(`Error fetching organization users: ${error.message}`);
      setOrganizationUsers([]); // Set to empty array on error
    } finally {
      setUsersLoading(false);
    }
  };

  const handleChange = (e) => {
    setTeamData({ ...teamData, [e.target.name]: e.target.value });
  };

  //   const handleAddMember = () => {
  //     if (newMember.trim() && !teamData.teamMembers.includes(newMember.trim())) {
  //       setTeamData({
  //         ...teamData,
  //         teamMembers: [...teamData.teamMembers, newMember.trim()],
  //       });
  //       setNewMember("");
  //     }
  //   };

  //   const handleRemoveMember = (memberToRemove) => {
  //     setTeamData({
  //       ...teamData,
  //       teamMembers: teamData.teamMembers.filter(
  //         (member) => member !== memberToRemove
  //       ),
  //     });
  //   };

  // Replace the current handleAddMember function
  const handleAddMember = (userId) => {
    console.log("Adding member with userId:", userId, "Type:", typeof userId);

    // Ensure it's a string and not an object
    const userIdString = String(userId);
    console.log("Converted userId:", userIdString);

    if (
      userIdString &&
      userIdString !== "undefined" &&
      !teamData.teamMembers.includes(userIdString)
    ) {
      setTeamData({
        ...teamData,
        teamMembers: [...teamData.teamMembers, userIdString],
      });
      setNewMember(""); // Reset dropdown
    } else {
      console.log("Invalid userId or already exists:", userIdString);
    }
  };

  // Replace the current handleRemoveMember function
  const handleRemoveMember = (memberToRemove) => {
    setTeamData({
      ...teamData,
      teamMembers: teamData.teamMembers.filter(
        (member) => member !== memberToRemove
      ),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Debug what's being sent
    console.log("Submitting team data:", teamData);
    console.log("Team members array:", teamData.teamMembers);
    console.log("Team members type:", typeof teamData.teamMembers[0]);
    try {
      if (mode === "create") {
        console.log("Creating team with data:", teamData);
        await saveTeam(teamData, userName);
        toast.success("🦄 Team Created Successfully");
      } else {
        await updateTeam(selectedTeam.teamId, teamData, userName);
        toast.success("🦄 Team Updated Successfully");
      }

      resetForm();
      setShowModal(false);
      fetchTeams(); // Refresh the teams list
    } catch (error) {
      toast.error(`🦄 Error saving team: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (team) => {
    setTeamData({
      teamName: team.teamName,
      teamMembers: team.teamMembers || [],
      orgId: team.orgId,
    });
    setSelectedTeam(team);
    setMode("edit");
    setShowModal(true);
  };

  //   const handleAddMembers = async () => {
  //     if (!newMember.trim()) return;

  //     try {
  //       await addTeamMembers(selectedTeam.teamId, [newMember.trim()], userName);
  //       toast.success("🦄 Team Member Added Successfully");
  //       setNewMember("");
  //       fetchTeams(); // Refresh the teams list
  //     } catch (error) {
  //       toast.error(`🦄 Error adding team member: ${error.message}`);
  //     }
  //   };

  const handleAddMembers = async () => {
    if (!newMember.trim() || !selectedTeam) {
      toast.error("Please select a team member");
      return;
    }

    try {
      const memberIdString = String(newMember.trim());
      await addTeamMembers(selectedTeam.teamId, [memberIdString], userName);
      toast.success("🦄 Team Member Added Successfully");
      setNewMember(""); // Reset dropdown after adding

      // Update selectedTeam to reflect the new member immediately
      setSelectedTeam((prev) => ({
        ...prev,
        teamMembers: [...(prev.teamMembers || []), memberIdString],
      }));

      fetchTeams(); // Refresh the teams list
    } catch (error) {
      toast.error(`🦄 Error adding team member: ${error.message}`);
    }
  };

  //   const handleRemoveMemberFromTeam = async (memberId) => {
  //     try {
  //       await removeTeamMembers(selectedTeam.teamId, [memberId], userName);
  //       toast.success("🦄 Team Member Removed Successfully");
  //       fetchTeams(); // Refresh the teams list
  //     } catch (error) {
  //       toast.error(`🦄 Error removing team member: ${error.message}`);
  //     }
  //   };

  const handleRemoveMemberFromTeam = async (memberId) => {
    try {
      await removeTeamMembers(selectedTeam.teamId, [memberId], userName);
      toast.success("🦄 Team Member Removed Successfully");

      // Update selectedTeam to remove the member immediately
      setSelectedTeam((prev) => ({
        ...prev,
        teamMembers: (prev.teamMembers || []).filter(
          (member) => member !== memberId
        ),
      }));

      fetchTeams(); // Refresh the teams list
    } catch (error) {
      toast.error(`🦄 Error removing team member: ${error.message}`);
    }
  };

  const resetForm = () => {
    setTeamData({
      teamName: "",
      teamMembers: [],
      orgId: orgId || "",
    });
    setNewMember("");
    setSelectedTeam(null);
    setMode("create");
  };

  const openMembersModal = (team) => {
    setSelectedTeam(team);
    setShowMembersModal(true);
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fields-title">Team Management</h2>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
            className="fields-submit"
          >
            Create New Team
          </Button>
        </div>

        {loading && (
          <div className="loading-overlay">
            <Sample14 />
          </div>
        )}

        {/* Teams List */}
        <Row>
          {teams.map((team) => (
            <Col md={6} lg={4} key={team.teamId} className="mb-4">
              <Card className="h-100">
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">{team.teamName}</h5>
                  <Badge bg="primary">
                    {team.teamMembers?.length || 0} members
                  </Badge>
                </Card.Header>
                <Card.Body>
                  <p className="text-muted mb-2">Team ID: {team.teamId}</p>
                  <div className="mb-3">
                    <strong>Members:</strong>
                    <div className="mt-1">
                      {team.teamMembers?.slice(0, 3).map((memberId, index) => {
                        const user = organizationUsers.find(
                          (u) => String(u.userId) === memberId
                        );
                        const displayName = user ? user.username : memberId;
                        return (
                          <Badge
                            key={index}
                            bg="secondary"
                            className="me-1 mb-1"
                          >
                            {displayName}
                          </Badge>
                        );
                      })}
                      {team.teamMembers?.length > 3 && (
                        <Badge bg="light" text="dark">
                          +{team.teamMembers.length - 3} more
                        </Badge>
                      )}
                    </div>
                  </div>
                  <p className="text-muted small">
                    Created: {team.createdOnDate} by {team.createdBy}
                  </p>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex gap-2">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => openMembersModal(team)}
                    >
                      Manage Members
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => handleEdit(team)}
                    >
                      Edit
                    </Button>
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>

        {teams.length === 0 && (
          <div className="text-center py-5">
            <h5 className="text-muted">No teams found</h5>
            <p>Create your first team to get started</p>
          </div>
        )}

        {/* Create/Edit Team Modal */}
        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
            resetForm();
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {mode === "create" ? "Create New Team" : "Edit Team"}
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Team Name <span className="text-red">**</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="teamName"
                      value={teamData.teamName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Team Members</Form.Label>

                    {/* Dropdown for adding members */}
                    {/* Add New Member */}
                    <div className="d-flex mb-3">
                      <Form.Select
                        value={newMember}
                        onChange={(e) => {
                          console.log(
                            "Selected value:",
                            e.target.value,
                            "Type:",
                            typeof e.target.value
                          );
                          setNewMember(e.target.value);
                        }}
                      >
                        <option value="">Select a team member</option>
                        {organizationUsers.map((user) => (
                          <option key={user.userId} value={user.userId}>
                            {user.username} (ID: {user.userId})
                          </option>
                        ))}
                      </Form.Select>
                      <Button
                        variant="outline-primary"
                        className="ms-2"
                        onClick={() => handleAddMember(newMember)} // Pass newMember explicitly
                        disabled={!newMember}
                      >
                        Add Member
                      </Button>
                    </div>

                    {/* Selected Members */}
                    <div className="selected-members mt-2">
                      {teamData.teamMembers.map((memberId, index) => {
                        const user = organizationUsers.find(
                          (u) => String(u.userId) === memberId
                        );
                        const displayName = user
                          ? `${user.username}`
                          : memberId;

                        return (
                          <Badge key={index} bg="primary" className="me-1 mb-1">
                            {displayName}
                            <span
                              className="ms-1 cursor-pointer"
                              onClick={() => handleRemoveMember(memberId)}
                              style={{ cursor: "pointer" }}
                            >
                              ×
                            </span>
                          </Badge>
                        );
                      })}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowModal(false);
                  resetForm();
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading
                  ? "Saving..."
                  : mode === "create"
                  ? "Create Team"
                  : "Update Team"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* Manage Members Modal */}
        <Modal
          show={showMembersModal}
          onHide={() => setShowMembersModal(false)}
          size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Manage Team Members - {selectedTeam?.teamName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Add New Member - Changed to dropdown */}
            <div className="d-flex mb-3">
              <Form.Select
                value={newMember}
                onChange={(e) => {
                  console.log(
                    "Selected value in manage modal:",
                    e.target.value,
                    "Type:",
                    typeof e.target.value
                  );
                  setNewMember(e.target.value);
                }}
              >
                <option value="">Select a team member</option>
                {organizationUsers
                  .filter(
                    (user) =>
                      !selectedTeam?.teamMembers?.includes(String(user.userId))
                  )
                  .map((user) => (
                    <option key={user.userId} value={user.userId}>
                      {user.username} (ID: {user.userId})
                    </option>
                  ))}
              </Form.Select>
              <Button
                variant="outline-primary"
                className="ms-2"
                onClick={handleAddMembers}
                disabled={!newMember}
              >
                Add Member
              </Button>
            </div>

            {/* Current Members List */}
            <h6>Current Members ({selectedTeam?.teamMembers?.length || 0})</h6>
            <div className="members-list">
              {selectedTeam?.teamMembers?.map((memberId, index) => {
                const user = organizationUsers.find(
                  (u) => String(u.userId) === memberId
                );
                const displayName = user
                  ? `${user.username}`
                  : `User ID: ${memberId}`;

                return (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center p-2 border-bottom"
                  >
                    <span>{displayName}</span>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => handleRemoveMemberFromTeam(memberId)}
                    >
                      Remove
                    </Button>
                  </div>
                );
              })}
              {(!selectedTeam?.teamMembers ||
                selectedTeam.teamMembers.length === 0) && (
                <p className="text-muted text-center py-3">
                  No members in this team
                </p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowMembersModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default TeamMaster;
